// extracted by mini-css-extract-plugin
export default {"Dropzone":"Dropzone__CuQcbUFCOQUp","Curtain":"Curtain__phmnpbxiMDAP","Indicator":"Indicator__WyHuIDJ2FNt9","ButtonHint":"ButtonHint__SDj37W0g5aeY"};